const channelFromUtmMedium = utmMedium => {
  const utmMediumMapping = {
    email: ['email'],
    organic: ['organic'],
    social: ['social', 'social-network', 'social-media', 'sm', 'social media', 'social network'],
    referral: ['referral'],
    paid_search: ['paid_search', 'cpc', 'ppc', 'paidsearch', 'paid', 'GoogleAds'],
    display: ['display', 'cpm', 'banner'],
    paid_social: ['paid_social', 'paid+social', 'paid social', 'paidsocial', 'jobposting'],
  };

  for (const channel in utmMediumMapping) {
    if (utmMediumMapping[channel].includes(utmMedium)) return channel;
  }
};

const channelFromUtmSource = utmSource => {
  const utmSourceMapping = {
    email: ['hs_email', 'mailchimp'],
    organic: ['google', 'yahoo', 'bing', 'aol'],
    social: ['facebook', 'facebook.com', 'instagram', 'twitter', 'twitter.com', 'linkedin', 'linkedin.com'],
    paid_search: ['adwords'],
  };

  for (const channel in utmSourceMapping) {
    if (utmSourceMapping[channel].includes(utmSource)) return channel;
  }
};

const channelFromOtherQueryParams = (gclid, fbclid) => {
  if (gclid) return 'paid_search';
  if (fbclid) return 'social';
};

const channelFromReferrer = (referrer, currentHostname) => {
  if (referrer) {
    const domainMapping = {
      direct: ['bravado.co'],
      organic: ['google.', 'duckduckgo', 'bing.', 'baidu.', 'yahoo.'], // added point to google. so it won't match with googleadservices or googleads
      social: ['facebook', 'linkedin', 'instagram', 'twitter', 'youtube.', 'lnkd.in'],
      paid_search: ['googleadservices'],
      display: ['doubleclick'],
    };

    const referrerDomain = new URL(referrer).hostname;

    for (const channel in domainMapping) {
      if (domainMapping[channel].some(domain => referrerDomain.includes(domain))) {
        return channel;
      }
    }

    if (referrerDomain === currentHostname) {
      return 'direct';
    } else {
      return 'referral';
    }
  }
};

export const detectChannel = () => {
  const queryParams = new URL(document.location).searchParams;
  return (
    channelFromUtmMedium(queryParams.get('utm_medium')) ||
    channelFromUtmSource(queryParams.get('utm_source')) ||
    channelFromOtherQueryParams(queryParams.get('gclid'), queryParams.get('fbclid')) ||
    channelFromReferrer(document.referrer, window.location.hostname) ||
    'direct'
  );
};
